import React, { useState, useEffect, Fragment } from "react";
import {
    Button,
    Chip,
    CircularProgress,
    colors,
    Container,
    FormControlLabel,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    TextField,
    Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { insh as inshst } from "../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import LockIcon from "@material-ui/icons/Lock";

import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";

import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial
} from '../../../../St/Reports/UseStyle';
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import InvoiceOilPayFilter from "./InvoiceOilPayFilter";
import { Autocomplete } from "@material-ui/lab";
import { Print } from "@material-ui/icons";
import { SaleCheckbox, useStylesCAB } from "../../../../St/comps/UseStyle";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function InvoiceOilPay(props) {
    const {
        fromQountity,
        setfromQountity,
        selectOilTypePay,
        subInfo,
        changSwitch,
        valueStock,
        AutoOptions,
        changAutoStock,
        changAutoBank,
        toPrint,
        valueBank,
        itemName,
        loading,
        idata,
        valuePumps,
        showPaid,
        setShowPaid,
    } = props;
    const clasAo = useStylesAuto();

    const clasup = useStylesUp();
    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const claslbls = useStylesLbl();

    const clasCAB = useStylesCAB();

    const { t } = useTranslation(["forms", "translation"]);

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: colors.green[300],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >

                    <InvoiceOilPayFilter {...{
                        fromQountity,
                        setfromQountity,
                        selectOilTypePay,
                        changSwitch,
                        idata
                    }} />

                    <Grid item lg={1} md={1} sm={2} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <FormControlLabel
                            id="showPaid"
                            value="showPaid"
                            name="showPaid"
                            className={claslbl.clor}
                            control={
                                <SaleCheckbox
                                    checked={showPaid}
                                    onChange={(e) => {
                                        setShowPaid(e.target.checked);
                                    }}
                                    color={ "primary"}
                                />
                            }
                            label={t("paid_screen")}
                            labelPlacement="end"
                        />
                    </Grid>
                    <Fragment>
                        <Grid item container justifyContent="center" xs={12} spacing={1}>
                            {AutoOptions?.permType?.id === 4 &&
                                (
                                    <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                        <TextField fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="symbol"
                                            label={"اسم المضخة"}
                                            className={clasTF.rootSale}
                                            InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                            InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                            type="text"
                                            name="pump"
                                            value={valuePumps?.name}
                                        />
                                    </Grid>
                                )}


                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                <TextField fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="symbol"
                                    label={t("item-name")}
                                    className={clasTF.rootSale}
                                    InputProps={{ className: claslbl.clrSale, readOnly: true }}
                                    InputLabelProps={{ className: claslbl.clrSale }}
                                    type="text"
                                    name="symbol"
                                    value={itemName ?? ""}
                                /></Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                <TextField fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="symbol"
                                    label={t("total")}
                                    className={clasTF.rootSale}
                                    InputProps={{ className: claslbl.clrSale, readOnly: true }}
                                    InputLabelProps={{ className: claslbl.clrSale }}
                                    type="number"
                                    name="symbol"
                                    value={idata?.netAmount}
                                /></Grid>
                            {fromQountity?.pay?.id == 1 &&
                                <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "1rem" }}>
                                    <Autocomplete
                                        classes={clasAo}
                                        value={valueStock}
                                        onChange={(event, newValue) => {
                                            changAutoStock(newValue);
                                        }}
                                        id="controllable-states-demo"
                                        size="small"
                                        options={AutoOptions.Stocks}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                id="bank"
                                                {...params}
                                                label={t("account")}
                                                variant="outlined"
                                                size="small"
                                                InputLabelProps={{ className: claslbls.clrBlackLblSal }}
                                            />
                                        )}
                                    />

                                </Grid>

                            }
                            {fromQountity?.pay?.id == 2 &&
                                <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "1rem" }}>
                                    <Autocomplete
                                        classes={clasAo}
                                        value={valueBank}
                                        onChange={(event, newValue) => {
                                            changAutoBank(newValue);
                                        }}
                                        id="controllable-states-demo"
                                        size="small"
                                        options={AutoOptions.Banks}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                id="bank"
                                                {...params}
                                                label={"الحساب"}
                                                variant="outlined"
                                                size="small"
                                                InputLabelProps={{ className: claslbls.clrBlackLblSal }}
                                            />
                                        )}
                                    />

                                </Grid>

                            }

                            <br />
                            <br />
                            <br />
                            <br />

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Button
                                    fullWidth
                                    autoFocus
                                    variant="contained"
                                    color="primary"
                                    onClick={() => toPrint("print", "e", 1)}
                                    style={{
                                        background: colors.green[500],
                                        ...{
                                            paddingLeft: 0,
                                            paddingRight: 0,
                                        },
                                    }}
                                    startIcon={<Print />}
                                >
                                    {" "}
                                    {"  .    دفع    ."}
                                    {(loading.print || loading.save) && (
                                        <CircularProgress
                                            size={24}
                                            className={clasCAB.buttonProgressCAB}
                                        />
                                    )}
                                </Button>
                            </Grid>

                        </Grid>

                    </Fragment>


                </Container>


            </Grid>
        </React.Fragment>
    );
}
